// removed by extract-text-webpack-plugin
module.exports = {"view":"style__view___3nfdh","title":"style__title___2VfF2","date":"style__date___12R_e","subtitle":"style__subtitle___95xmT","text":"style__text___2iU7A","textTitle":"style__textTitle___2d34-","link":"style__link___1EilJ"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/privacy/style.css
// module id = 117
// module chunks = 0